import DashboardClass from "@/utils/dashboard_class.ts";
import useLoans from "@/hooks/loans.ts";
import PlaneSuccessTemplate from "@/pages/success_screens/PlaneSuccessTemplate.tsx";

const SuccessCr = () => {
    const loan = useLoans()
    
    return (
        <PlaneSuccessTemplate
            upd={loan.updPendingLoans}
            nav={DashboardClass.dashboard_routes.PendingLoans}
        />
    )
}

export default SuccessCr